module.exports = [{"lineFieldId":"lines_HairCare","lines":["SUBLIMIC","SPA EXPERT","ADENOVITAL","FUTURE SUBLIME","FUENTE FORTE","AQUA INTENSIVE","LUMINOGENIC","SLEEKLINER","SALON SOLUTIONS","AIRY FLOW"]},{"lineFieldId":"lines_HairColor","lines":["PRIMIENCE","Colormuse","ULTIST"]},{"lineFieldId":"lines_Mens","lines":["THE GROOMING"]},{"lineFieldId":"lines_Styling","lines":["Stageworks"]},{"lineFieldId":"lines_Perm","lines":["CRYSTALLIZING QURL","CRYSTALLIZING STRAIGHT"]}]


//////////////////
// WEBPACK FOOTER
// ./src/pages/SalonLocator/data/lines/ko_kr.json
// module id = 817
// module chunks = 0